import { useState, useEffect } from 'react';

// Using the same breakpoint as Tailwind's 'sm' breakpoint
const MOBILE_BREAKPOINT = '(max-width: 768px)';

export const useMobileDetect = () => {
  // Initialize with the current match state
  const [isMobile, setIsMobile] = useState<boolean>(() =>
    window.matchMedia(MOBILE_BREAKPOINT).matches
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia(MOBILE_BREAKPOINT);

    const updateIsMobile = (e: MediaQueryListEvent) => {
      setIsMobile(e.matches);
    };

    // Add the listener
    mediaQuery.addEventListener('change', updateIsMobile);

    // Cleanup
    return () => {
      mediaQuery.removeEventListener('change', updateIsMobile);
    };
  }, []);

  return isMobile;
};

export default useMobileDetect;